import { differenceInMonths, format } from 'date-fns';
import type { Active } from '../models/Active';
import type { Breed } from '../models/Breed';
import type { Color } from '../models/Color';
import type { Farm } from '../models/Farm';
import type { Gender } from '../models/Gender';
import { toast } from 'react-toastify';
import imageCompression from 'browser-image-compression';

export const numberOrNull = (value?: string | number | null) => {
  if (value === undefined || value === null) return null;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    if (value.trim() === '') return null;
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }
};

export async function compressImage(file: File, useWebWorker: boolean) {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 800,
    useWebWorker,
    // onProgress: (p: number) => onProgress(p, useWebWorker),
  };

  const output = await imageCompression(file, options);

  return output;
}

export const formatDate = (date: string | Date) =>
  format(new Date(date), 'MM/dd/yyyy');

export const getAge = (dateOfBirth: string) => {
  const months = Math.abs(
    differenceInMonths(new Date(dateOfBirth), new Date()),
  );
  const years = Math.floor(months / 12);
  const remainderMonths = months % 12;

  return `${years} yrs ${remainderMonths} mths`;
};

export const scrollIntoView = (id: string) => {
  if (document.getElementById(id) != null) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }
};

export const getGenderName = (genders: Gender[], genderId: number) => {
  if (genderId == 0) return;
  const gender = genders.filter((g) => g.genderId == genderId);
  return gender[0].genderName;
};

export const getColorName = (colors: Color[], colorId: number) => {
  if (colorId == 0) return;
  const color = colors.filter((c) => c.colorId == colorId);
  return color[0].colorName;
};

export const getBreedName = (breeds: Breed[], breedId: number) => {
  if (breedId == 0) return;
  const breed = breeds.filter((c) => c.breedId == breedId);
  return breed[0].breedName;
};

export const getFarmName = (farms: Farm[], farmId: number) => {
  if (farmId == 0) return;
  const farm = farms.filter((c) => c.farmId == farmId);
  return farm[0].name;
};

export const getActiveStatusName = (
  activeStatuses: Active[],
  activeId: number,
) => {
  if (activeId == 0) return;
  const status = activeStatuses.filter((c) => c.activeId == activeId);
  return status[0].status;
};

// export const debounce = (fn: Function, ms = 300) => {
//   let timeoutId: ReturnType<typeof setTimeout>;
//   return function (this: any, ...args: any[]) {
//     clearTimeout(timeoutId);
//     timeoutId = setTimeout(() => fn.apply(this, args), ms);
//   };
// };

export function ToastFunction(
  message?: string,
  type?: string,
  toastId?: string,
) {
  console.log(message);
  if (message) {
    switch (type) {
      case 'error':
        return toast.error(message, { toastId: toastId ?? '' });
      case 'info':
        return toast.info(message, { toastId: toastId ?? '' });
      case 'success':
        return toast.success(message, { toastId: toastId ?? '' });
      default:
        break;
    }
  }
}

// genders
// optionMethod={(genders: Gender[]) =>
//   genders.map((g) => (
//     <option value={g.genderId} key={g.genderId}>
//       {g.genderName}
//     </option>
//   ))
// }
